import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type PlatformsMessages = SidebarMessages & {
  platformsPageTitle: string;
  communication: string;
  "e-commerce": string;
  erp: string;
  payment: string;
  logistics: string;
  attendance: string;
  connectButtonLabel: string;
  soonButtonLabel: string;
  disconnectButtonLabel: string;
  configButtonLabel: string;
  consultButtonLabel: string;
  consultModalTitle: string;
  consultModalDescription: string;
  consultModalMessageTypeLabel: string;
  consultModalMessageTypeValue: string;
  consultModalSubjectLabel: string;
  consultModalMessageLabel: string;
  consultModalMessageValue: string;
  consultModalOpenPortalButton: string;
  consultModalCloseButton: string;
};

export const PLATFORMS_MESSAGES: PlatformsMessages = {
  ...SIDEBAR_MESSAGES,

  platformsPageTitle: "Plataformas",

  communication: "Comunicação",
  "e-commerce": "E-commerce",
  erp: "ERP",
  payment: "Pagamento",
  logistics: "Logística",
  attendance: "Atendimento",

  connectButtonLabel: "Conectar",
  soonButtonLabel: "Em breve",
  disconnectButtonLabel: "Desconectar",
  configButtonLabel: "Configurações",
  consultButtonLabel: "Consulte",
  consultModalTitle: "Ativar plataforma",
  consultModalDescription:
    "Para ativar essa plataforma entre no nosso portal de chamados e abra um ticket.",
  consultModalMessageTypeLabel: "Tipo de mensagem",
  consultModalMessageTypeValue: "Configuração",
  consultModalSubjectLabel: "Assunto",
  consultModalMessageLabel: "Mensagem",
  consultModalMessageValue: "Detalhar sua necessidade para uso dessa plataforma.",
  consultModalOpenPortalButton: "Abrir portal de chamados",
  consultModalCloseButton: "Fechar",
};
